module.exports = __webpack_public_path__ + "media/images/categories/carousel/marketing-356d6e6ec5d357c8feebf23da00d6467.jpg";